import FormField from "./FormField";
import Placeholder from "../../Placeholder";
import PropTypes from "prop-types";
import React, {useEffect} from "react";
import RelationshipField from "./RelationshipField";
import duckify from "../../../utils/duckify";
import {useFormikContext} from "formik";
import {sharedPortalParents} from "../../../ducks";
import ParentField from "./ParentField";

const formatName = (parent) =>
  [
    parent.first_name,
    parent.last_name,
    parent.name_suffix
  ].filter(v => v !== null && v !== undefined).join(" ")
;

/**
 * Select an existing parent, or create a new one.
 */
const ParentIntakeField = ({label, editable, entity, parents, duckMeta, required}) => {
  const {values, setValues} = useFormikContext();
  const selectOptions = parents
    .map(p => ({label: formatName(p), value: p.id}))
    .concat({label: "Add a new parent", value: "__new__"});
  const ready = !duckMeta.parents || duckMeta.parents.ready;

  const parentId = values[`${entity}_id`];
  const isEditable = parentId === "__new__" || parentId && editable(parentId);

  // Update parent form values when selection changes
  useEffect(() => {
    if (parentId) {
      const parent = parentId === "__new__"
        ? {id: parentId}
        : parents.find(p => p.id === parentId);

      if (parent) {
        setValues({...values, [entity]: parent});
      }
    }
  }, [parentId]);

  if (!ready) {
    return (<Placeholder.text/>);
  } else {
    return (
      <React.Fragment>
        <div className="sp-parent-select row">
          <div className="col-12">
            {parents.length !== 0 && (
              <FormField
                name={`${entity}_id`}
                label={label}
                type="select"
                options={selectOptions}
                required={required}
              />
            )}
          </div>
        </div>

        {isEditable && (<ParentField entity={entity} required={required} />)}

        <RelationshipField name={`${entity}_relationship.relationship`} label="Relationship to Student" required={required} />
      </React.Fragment>
    );
  }
}

ParentIntakeField.defaultProps = {
  editable: (_parentId) => false,
};

ParentIntakeField.propTypes = {
  label: PropTypes.string,
  entity: PropTypes.string.isRequired,

  /* Function that takes a parentId and returns true if editable */
  editable: PropTypes.func,
};

const mapDucksToProps = () => ({parents: sharedPortalParents});

export default duckify(mapDucksToProps)(ParentIntakeField);
